import { render, staticRenderFns } from "./client_generica.vue?vue&type=template&id=6bc65ae3&"
import script from "./client_generica.vue?vue&type=script&lang=js&"
export * from "./client_generica.vue?vue&type=script&lang=js&"
import style0 from "./client_generica.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports